// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-tab {
  padding: 10px;
  overflow: auto;
  height: 100%;
  max-height: calc(100vh - 150px);
  /* When maximized view is active, don't apply overflow/max-height constraints */
}
.dashboard-tab:has(.maximized-view.fullheight) {
  overflow: visible !important;
  max-height: none !important;
}
.dashboard-tab.fullheight {
  min-height: 100vh;
  height: 100vh;
  display: flex;
  flex-direction: column;
}
.dashboard-tab .dashboard-actions {
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
}
.dashboard-tab .dashboard-actions .mb-3 {
  margin-bottom: 0 !important;
  display: flex;
  align-items: center;
  gap: 10px;
}
.dashboard-tab .dashboard-actions .form-label {
  font-size: 13px;
  font-weight: 600;
  color: #333;
  margin-bottom: 0;
  white-space: nowrap;
}
.dashboard-tab .dashboard-actions .view-dropdown {
  font-size: 13px;
  padding: 5px 10px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  width: 140px;
  height: 32px;
}
.dashboard-tab .dashboard-actions .view-dropdown:focus {
  border-color: inherit;
  box-shadow: none;
}
.dashboard-tab .dashboard-actions .refresh-button {
  background-color: #003da5;
  border-color: #003da5;
  color: #fff;
  padding: 5px 10px;
  height: 32px;
  font-size: 13px;
}
.dashboard-tab .dashboard-actions .refresh-button .pi {
  font-size: 14px;
}
.dashboard-tab .dashboard-actions .refresh-button:hover {
  background-color: #002d7a;
  border-color: #002d7a;
}
.dashboard-tab .dashboard-actions .refresh-button:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 61, 165, 0.25);
}
.dashboard-tab .view-container {
  display: flex;
  gap: 20px;
  margin-top: 10px;
}
.dashboard-tab .view-container .view-column {
  flex-grow: 0;
  flex-shrink: 0;
  flex-basis: calc(50% - 10px);
  width: calc(50% - 10px);
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.dashboard-tab .view-container .view-column .view-accordion .p-accordion-header {
  border-radius: 6px;
}
.dashboard-tab .view-container .view-column .view-accordion .p-accordion-header .p-accordion-header-link {
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 0px 10px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  background: inherit;
}
.dashboard-tab .view-container .view-column .view-accordion .p-accordion-header .p-accordion-header-link:focus {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.dashboard-tab .view-container .view-column .view-accordion .p-accordion-header:not(.p-disabled).p-highlight .p-accordion-header-link {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.dashboard-tab .view-container .view-column .view-accordion .p-accordion-content {
  border: 1px solid #ddd;
  border-top: none;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  padding: 0;
}
.dashboard-tab .view-container .view-column .view-accordion .p-accordion-tab {
  margin-bottom: 12px;
}
.dashboard-tab .view-container .view-column .view-accordion .p-accordion-tab:last-child {
  margin-bottom: 0;
}
.dashboard-tab .view-container .view-column .view-accordion .p-toggleable-content {
  border: none;
}
.dashboard-tab .view-container .view-column .view-item-content {
  max-height: 200px;
  height: auto;
  width: 100%;
  overflow-y: auto;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
}
.dashboard-tab .view-container .view-column .view-item-content .status-icon-column .pi {
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
  font-weight: 500;
  font-size: 20px;
}
.dashboard-tab .view-container .view-column .view-item-content p {
  margin: 4px 0;
  font-size: 12px;
  color: #666;
}
.dashboard-tab .view-container .empty-dashboard-help {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60vh;
  width: 100%;
}
.dashboard-tab .view-container .empty-dashboard-help .empty-dashboard-help-content {
  text-align: center;
  background: #f8fafc;
  border-radius: 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);
  padding: 40px 32px;
  min-width: 320px;
  max-width: 480px;
}
.dashboard-tab .view-container .empty-dashboard-help .empty-dashboard-help-content .empty-dashboard-help-title {
  font-size: 1.5em;
  color: #333;
  margin-bottom: 12px;
  font-weight: 600;
  letter-spacing: 0.2px;
}
.dashboard-tab .view-container .empty-dashboard-help .empty-dashboard-help-content .empty-dashboard-help-desc {
  color: #666;
  font-size: 1.1em;
  margin-bottom: 0;
  line-height: 1.6;
}
.dashboard-tab .view-container .empty-dashboard-help .empty-dashboard-help-content .empty-dashboard-help-desc .empty-dashboard-help-highlight {
  color: #1976d2;
  font-weight: 700;
}
.dashboard-tab .awm-dashboard-grid {
  /* Custom thin scrollbar for grid */
  /* For Firefox */
  scrollbar-width: 4px !important;
}
.dashboard-tab .awm-dashboard-grid .project-link {
  color: #003DA5;
}
.dashboard-tab .awm-dashboard-grid .status-value {
  padding: 0;
}
.dashboard-tab .awm-dashboard-grid ::-webkit-scrollbar {
  width: 4px !important;
  height: 4px !important;
}
.dashboard-tab .awm-dashboard-grid ::-webkit-scrollbar-thumb {
  border-radius: 2px;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Tabs/DashboardTab/DashboardTab.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,cAAA;EACA,YAAA;EACA,+BAAA;EAEA,+EAAA;AAAJ;AACI;EACI,4BAAA;EACA,2BAAA;AACR;AAEI;EACI,iBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;AAAR;AAGI;EACI,mBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,SAAA;AADR;AAGQ;EACI,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AADZ;AAIQ;EACI,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;AAFZ;AAKQ;EACI,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;AAHZ;AAKY;EACI,qBAAA;EACA,gBAAA;AAHhB;AAOQ;EACI,yBAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,eAAA;AALZ;AAOY;EACI,eAAA;AALhB;AAQY;EACI,yBAAA;EACA,qBAAA;AANhB;AASY;EACI,+CAAA;AAPhB;AAYI;EACI,aAAA;EACA,SAAA;EACA,gBAAA;AAVR;AAYQ;EACI,YAAA;EAAA,cAAA;EAAA,4BAAA;EACA,uBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAVZ;AAagB;EACI,kBAAA;AAXpB;AAaoB;EACI,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,yCAAA;EACA,mBAAA;AAXxB;AAawB;EACI,yCAAA;AAX5B;AAeoB;EACI,4BAAA;EACA,6BAAA;AAbxB;AAiBgB;EACI,sBAAA;EACA,gBAAA;EACA,8BAAA;EACA,+BAAA;EACA,UAAA;AAfpB;AAkBgB;EACI,mBAAA;AAhBpB;AAkBoB;EACI,gBAAA;AAhBxB;AAoBgB;EACI,YAAA;AAlBpB;AAsBY;EACI,iBAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;AApBhB;AAuBoB;EACI,6BAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;AArBxB;AAyBgB;EACI,aAAA;EACA,eAAA;EACA,WAAA;AAvBpB;AA4BQ;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,WAAA;AA1BZ;AA4BY;EACI,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AA1BhB;AA4BgB;EACI,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,qBAAA;AA1BpB;AA6BgB;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;AA3BpB;AA6BoB;EACI,cAAA;EACA,gBAAA;AA3BxB;AAkCI;EASI,mCAAA;EAUA,gBAAA;EACA,+BAAA;AAjDR;AA8BQ;EACI,cAAA;AA5BZ;AA+BQ;EACI,UAAA;AA7BZ;AAiCQ;EACI,qBAAA;EACA,sBAAA;AA/BZ;AAkCQ;EACI,kBAAA;AAhCZ","sourcesContent":[".dashboard-tab {\n    padding: 10px;\n    overflow: auto;\n    height: 100%;\n    max-height: calc(100vh - 150px);\n\n    /* When maximized view is active, don't apply overflow/max-height constraints */\n    &:has(.maximized-view.fullheight) {\n        overflow: visible !important;\n        max-height: none !important;\n    }\n\n    &.fullheight {\n        min-height: 100vh;\n        height: 100vh;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .dashboard-actions {\n        margin-bottom: 10px;\n        display: flex;\n        justify-content: flex-end;\n        align-items: center;\n        gap: 15px;\n\n        .mb-3 {\n            margin-bottom: 0 !important;\n            display: flex;\n            align-items: center;\n            gap: 10px;\n        }\n\n        .form-label {\n            font-size: 13px;\n            font-weight: 600;\n            color: #333;\n            margin-bottom: 0;\n            white-space: nowrap;\n        }\n\n        .view-dropdown {\n            font-size: 13px;\n            padding: 5px 10px;\n            border: 1px solid #ced4da;\n            border-radius: 4px;\n            width: 140px;\n            height: 32px;\n\n            &:focus {\n                border-color: inherit;\n                box-shadow: none;\n            }\n        }\n\n        .refresh-button {\n            background-color: #003da5;\n            border-color: #003da5;\n            color: #fff;\n            padding: 5px 10px;\n            height: 32px;\n            font-size: 13px;\n\n            .pi {\n                font-size: 14px;\n            }\n\n            &:hover {\n                background-color: #002d7a;\n                border-color: #002d7a;\n            }\n\n            &:focus {\n                box-shadow: 0 0 0 0.2rem rgba(0, 61, 165, 0.25);\n            }\n        }\n    }\n\n    .view-container {\n        display: flex;\n        gap: 20px;\n        margin-top: 10px;\n\n        .view-column {\n            flex: 0 0 calc(50% - 10px);\n            width: calc(50% - 10px);\n            display: flex;\n            flex-direction: column;\n            gap: 20px;\n\n            .view-accordion {\n                .p-accordion-header {\n                    border-radius: 6px;\n\n                    .p-accordion-header-link {\n                        border: 1px solid #ddd;\n                        border-radius: 6px;\n                        padding: 0px 10px;\n                        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n                        background: inherit;\n\n                        &:focus {\n                            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n                        }\n                    }\n\n                    &:not(.p-disabled).p-highlight .p-accordion-header-link {\n                        border-bottom-left-radius: 0;\n                        border-bottom-right-radius: 0;\n                    }\n                }\n\n                .p-accordion-content {\n                    border: 1px solid #ddd;\n                    border-top: none;\n                    border-bottom-left-radius: 6px;\n                    border-bottom-right-radius: 6px;\n                    padding: 0;\n                }\n\n                .p-accordion-tab {\n                    margin-bottom: 12px;\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n\n                .p-toggleable-content {\n                    border: none;\n                }\n            }\n\n            .view-item-content {\n                max-height: 200px;\n                height: auto;\n                width: 100%;\n                overflow-y: auto;\n                overflow-x: auto;\n                display: flex;\n                flex-direction: column;\n\n                .status-icon-column {\n                    .pi {\n                        position: relative !important;\n                        top: 0 !important;\n                        right: 0 !important;\n                        font-weight: 500;\n                        font-size: 20px;\n                    }\n                }\n\n                p {\n                    margin: 4px 0;\n                    font-size: 12px;\n                    color: #666;\n                }\n            }\n        }\n\n        .empty-dashboard-help {\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            height: 60vh;\n            width: 100%;\n\n            .empty-dashboard-help-content {\n                text-align: center;\n                background: #f8fafc;\n                border-radius: 16px;\n                box-shadow: 0 2px 12px rgba(0, 0, 0, 0.07);\n                padding: 40px 32px;\n                min-width: 320px;\n                max-width: 480px;\n\n                .empty-dashboard-help-title {\n                    font-size: 1.5em;\n                    color: #333;\n                    margin-bottom: 12px;\n                    font-weight: 600;\n                    letter-spacing: 0.2px;\n                }\n\n                .empty-dashboard-help-desc {\n                    color: #666;\n                    font-size: 1.1em;\n                    margin-bottom: 0;\n                    line-height: 1.6;\n\n                    .empty-dashboard-help-highlight {\n                        color: #1976d2;\n                        font-weight: 700;\n                    }\n                }\n            }\n        }\n    }\n\n    .awm-dashboard-grid {\n        .project-link {\n            color: #003DA5;\n        }\n\n        .status-value {\n            padding: 0;\n        }\n\n        /* Custom thin scrollbar for grid */\n        ::-webkit-scrollbar {\n            width: 4px !important;\n            height: 4px !important;\n        }\n\n        ::-webkit-scrollbar-thumb {\n            border-radius: 2px;\n        }\n\n        /* For Firefox */\n        scrollbar-width: 4px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
